import { ConfirmService } from "../services/confirm";

// eslint-disable-next-line import/prefer-default-export
export const confirmService = new ConfirmService();
